import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-check-view container" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = {
  class: "alert alert-dismissible alert-warning",
  role: "alert"
}
const _hoisted_4 = { class: "alert__icon" }
const _hoisted_5 = { class: "row d-flex" }
const _hoisted_6 = { class: "col-12 mt-3 justify-content-end d-flex flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Wizzard = _resolveComponent("Wizzard")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_DynamicSummary = _resolveComponent("DynamicSummary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Breadcrumb)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_Wizzard, { "current-page": "check" })
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title-info-check text-start" }, [
      _createElementVNode("h1", { class: "mb-5" }, "Confira seus dados.")
    ], -1)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Icon, { name: "circle-exclamation" })
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "alert__content text-start" }, " Atenção! Verifique se os dados estão corretos antes de finalizar, pois não será possível fazer alterações após a emissão do Certificado Digital. ", -1))
    ]),
    _createVNode(_component_DynamicSummary),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "col-12 col-md-3 btn btn-primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.finishJorney && _ctx.finishJorney(...args)))
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "me-3" }, "Avançar", -1)),
          _createVNode(_component_Icon, { name: "arrow-right" })
        ])
      ])
    ])
  ]))
}